import { render, staticRenderFns } from "./AttachmentShardView.vue?vue&type=template&id=03f4a6cf&scoped=true&"
import script from "./AttachmentShardView.vue?vue&type=script&lang=ts&"
export * from "./AttachmentShardView.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentShardView.vue?vue&type=style&index=0&id=03f4a6cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f4a6cf",
  null
  
)

export default component.exports